require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-2017-software-developer-gift-guide.json") })
        }
      }, "path---blog-2017-software-developer-gift-guide");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-2017-software-developer-gift-guide!./.cache/json/blog-2017-software-developer-gift-guide.json
// module id = 550
// module chunks = 231608221292675